import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import ReportPage from "@/pages/ReportPage";
import Account from "@/pages/Account";
import AuditIntakePage from "@/pages/AuditIntakePage";
import AuditReportPage from "@/pages/AuditReportPage";
import AuditClaimPage from "@/pages/AuditClaimPage";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import LegalPage from "@/pages/LegalPage";
import ToolsIndex from "./pages/ToolsIndex";
import ToolPage from "./pages/ToolPage";
import ErrorBoundary from "@/components/ErrorBoundary";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/report/:id" element={<ReportPage />} />
      <Route path="/account" element={<Account />} />
      <Route path="/account/audit-intake/:sessionId" element={<AuditIntakePage />} />
      <Route path="/account/audit-report/:reportId" element={<AuditReportPage />} />
      <Route path="/audit/claim/:token" element={<AuditClaimPage />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/checkout/cancel" element={<CheckoutCancel />} />
      {/* /method is HELD BACK pending the operator's own review of the copy.
          The page is a public representation under ACL s.18 and every claim on
          it has to be checked against the engine before anyone can read it, so
          the route is unregistered rather than merely unlinked - an unlinked
          route is still a live URL that a link, a share or a crawler reaches.
          pages/Method.jsx stays on disk, unchanged, waiting for that review.
          To restore: re-add the import, this route, and the three links removed
          alongside it (Nav desktop, Nav mobile, PricingMatrix). */}
      <Route path="/tools" element={<ToolsIndex />} />
      <Route path="/tools/:slug" element={<ToolPage />} />
      <Route path="/legal/:slug" element={<LegalPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App min-h-screen bg-[#e8e4df] text-[#171717]">
      <BrowserRouter>
        <ErrorBoundary>
            <AppRouter />
        </ErrorBoundary>
      </BrowserRouter>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#f5f2ed",
            border: "1px solid #c9c3b8",
            color: "#171717",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
            letterSpacing: "0.03em",
          },
        }}
      />
    </div>
  );
}
